/**
 * Created by yinghe on 2017/8/8.
 */
const moment = require('moment')

const FULL_FORMAT = 'YYYY-MM-DD HH:mm:ss.SSS'
const DATE_FORMAT = 'YYYY-MM-DD'
const TIME_FORMAT = 'HH:mm:ss.SSS'

/**
 * 判断一个字符串是否是日期-时间类型
 * @param date
 * @returns {*}
 */
let isFullDate = date => {
  if (typeof date !== 'string' || !/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}.\d{3}$/.test(date)) {
    return false
  }
  
  return moment(date, FULL_FORMAT).isValid()
}

/**
 * 判断两个日期是否是同一天
 * @param oneDate
 * @param otherDate
 * @returns {*}
 */
let sameDay = (oneDate, otherDate) => {
  if (!exports.isFullDate(oneDate) || !exports.isFullDate(otherDate)) {
    throw new SysError(0, '错误的时间格式', {oneDate, otherDate})
  }
  
  return moment(oneDate).isSame(otherDate, 'day')
}

/**
 * 判断两个日期是不是同一个月
 * @param oneDate
 * @param otherDate
 * @returns {*}
 */
let sameMonth = (oneDate, otherDate) => {
  if (!exports.isFullDate(oneDate) || !exports.isFullDate(otherDate)) {
    throw new SysError(0, '错误的时间格式', {oneDate, otherDate})
  }
  
  return moment(oneDate).isSame(otherDate, 'month')
}

/**
 * 获取当前时间戳
 */
let getTimeStamp = () => {
  return (new Date()).getTime() / 1000
}
/**
 * 获取当前时间
 * @returns {string}
 */
let getFullDate = () => {
  return moment().format(FULL_FORMAT)
}

/**
 * 获取当前日期
 * @returns {string}
 */
let getDate = () => {
  return moment().format(DATE_FORMAT)
}
/**
 * 获取当前日期 时分秒为0，由于查询mongodb会有时区差别，此方法一般用于mongodb时间段查询条件使用
 * @returns {string}
 */
let getDateFull = () => {
  return moment(moment().format(DATE_FORMAT)).format(FULL_FORMAT);
};

/**
 * 获取当前时分秒
 * @returns {string}
 */
let getTime = () => {
  return moment().format(TIME_FORMAT)
}

/**
 * 计算2个时间的差值
 * @param day1
 * @param day2
 * @returns {number}
 */
let computeDays = (day1, day2) => {
  return moment(day1).diff(day2, 'days')
}
/**
 * 计算2个时间的差秒值
 * @param time1
 * @param time2
 * @returns {number}
 */
let computeSeconds = (time1, time2) => {
  return moment(time1).diff(time2, 'seconds')
}
/**
 * 获取一个日期前/后n天的日期
 * @param date
 * @param num
 * @returns {string}
 */
let computeDateByDay = (date, num) => {
  let d = date ? moment(date) : moment()
  return d.add(num, 'days').format(FULL_FORMAT)
}

/**
 * 时间戳格式化
 * @param timestamp
 * @param formatStr
 * @returns {string}
 */
let timestampFormat = (timestamp, formatStr) => {
  if (!timestamp) {
    return ''
  }
  if (timestamp.toString().length === 10) {
    timestamp = timestamp * 1000
  }
  let formatDate = moment(timestamp).format(formatStr)
  /* 格式化时间 */
  return formatDate
}
/**
 * 日期格式化
 * @param dateStr 日期字符串
 * @param toformat 要转换的日期格式
 * @returns {string}
 */
let dateFormat = (dateStr, toformat) => {
  if (!dateStr) {
    return ''
  }
  let formatDate = moment(dateStr, 'YYYY-MM-DDT HH:mm:ssZ').format(toformat)
  /* 格式化时间 */
  return formatDate
}

/**
 * 标准日期格式化
 * @param dateStr 日期字符串
 * @returns {string}
 */
let bzDateFormat = (dateStr) => {
  if (!dateStr) {
    return ''
  }
  var date = new Date(dateStr)
  let month = date.getMonth() + 1
  if (month < 10) {
    month = '0' + month
  }
  let day = date.getDate()
  if (day < 10) {
    day = '0' + day
  }
  let hours = date.getHours()
  if (hours < 10) {
    hours = '0' + hours
  }
  let minutes = date.getMinutes()
  if (minutes < 10) {
    minutes = '0' + minutes
  }
  let secounds = date.getSeconds()
  if (secounds < 10) {
    secounds = '0' + secounds
  }
  return date.getFullYear() + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + secounds
}

/**
 * 获取一个日期前所在周的开始日期和结束日期
 * @param dateStr 日期字符串
 * @param inFormat 原来日期格式
 * @returns {string}
 */
let getWeekStartEnd = (dateStr, inFormat) => {
  let week = {}
  let weekOfday = parseInt(moment(dateStr, inFormat).format('d')) // 计算传入日期是这周第几天 周一为一周中的第一天
  let start = moment().subtract(weekOfday - 1, 'days').format('YYYY-MM-DD') // 周一日期
  let end = moment().add(7 - weekOfday, 'days').format('YYYY-MM-DD') // 周日日期
  week.start_time = start
  week.end_time = end
  return week
}

/**
 * 获取一个日期前所在月的开始日期和结束日期
 * @param dateStr 日期字符串
 * @param inFormat 原来日期格式
 * @returns {string}
 */
let getMonthStartEnd = (dateStr, inFormat) => {
  let month = {}
  let start = moment(dateStr, inFormat).add(0, 'month').format('YYYY-MM') + '-01'
  let end = moment(start, inFormat).add(1, 'month').add(-1, 'days').format('YYYY-MM-DD')
  month.start_time = start
  month.end_time = end
  return month
}
/**
 * 获取一个日期前所在年的开始日期和结束日期
 * @param dateStr 日期字符串
 * @param inFormat 原来日期格式
 * @returns {string}
 */
let getYearStartEnd = (dateStr, inFormat) => {
  let year = {}
  let start = moment(dateStr, inFormat).format('YYYY') + '-01-01'
  let end = moment(dateStr, inFormat).format('YYYY') + '-12-31'
  year.start_time = start
  year.end_time = end
  return year
}
/**
 * 获取一个日期是否在一个日期之后
 * @param day1 日期1
 * @param day2 日期2
 * @returns {string}
 */
let dayBeforeDay = (day1, day2) => {
  return moment(day1).isBefore(day2)
}

/**
 * 获取N天之后/之后的时间
 * @param time -option
 */
let dayCaculateWithDate = (day, caculateNumber, time) => {
  
  let date = new Date(((new Date(day)).getTime() + 86400000 * caculateNumber));
  console.log(time);
  // time.setHours(0);
  // time.setMinutes(0);
  // time.setSeconds(0);
}
/**
 * 获取N天之后/之后的时间
 * @param time -option
 */
let getRelativeTime = (time) => {
  
  // console.log(time)
  let seconds = parseInt(computeSeconds(getFullDate(), time))
  // 秒
  if (seconds < 60) {
    return '刚刚'
  }
  // 分
  if (seconds > 60 && seconds < 60 * 60) {
    return parseInt(seconds / 60) + '分钟前'
  }
  // 小时
  if (seconds > 60 * 60 && seconds < 60 * 60 * 24) {
    return parseInt(seconds / (60 * 60)) + '小时前'
  }
  //
  if (seconds > 60 * 60 * 24) {
    return dateFormat(time, "MM-DD HH:mm")
  }
}

export {
  isFullDate,
  sameDay,
  sameMonth,
  getTimeStamp,
  getFullDate,
  getDate,
  getDateFull,
  getTime,
  computeDays,
  computeSeconds,
  computeDateByDay,
  timestampFormat,
  dateFormat,
  bzDateFormat,
  getWeekStartEnd,
  getMonthStartEnd,
  getYearStartEnd,
  dayBeforeDay,
  getRelativeTime
}



// WEBPACK FOOTER //
// ./src/libs/timeUtil.js